import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { api } from "@/lib/api";
import { useCart } from "@/context/CartContext";

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const [state, setState] = useState("checking");
  const { clear } = useCart();
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;
    const sid = params.get("session_id");
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid") { clear(); return setState("paid"); }
        if (data.status === "expired") return setState("failed");
      } catch { /* retry */ }
      if (++tries >= 10) return setState("timeout");
      setTimeout(poll, 2000);
    };
    poll();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div data-testid="payment-result" data-state={state} className="mx-auto max-w-md px-4 py-20 text-center">
      {state === "checking" && (<><Loader2 className="mx-auto h-10 w-10 animate-spin" /><h1 className="mt-4 text-2xl font-extrabold">Verifica del pagamento…</h1></>)}
      {state === "paid" && (
        <>
          <CheckCircle2 className="mx-auto h-12 w-12 text-emerald-600" />
          <h1 data-testid="payment-success-title" className="mt-4 text-2xl font-extrabold">Ordine confermato!</h1>
          <p className="mt-2 text-sm text-muted-foreground">Grazie per l'acquisto. Trovi il riepilogo in I miei ordini.</p>
          <Link to="/ordini" data-testid="payment-go-orders" className="btn-mc mt-6">I miei ordini</Link>
        </>
      )}
      {(state === "failed" || state === "timeout") && (
        <>
          <XCircle className="mx-auto h-12 w-12 text-red-600" />
          <h1 className="mt-4 text-2xl font-extrabold">{state === "failed" ? "Pagamento non riuscito" : "Pagamento in verifica"}</h1>
          <p className="mt-2 text-sm text-muted-foreground">Controlla I miei ordini tra qualche minuto o scrivici su WhatsApp.</p>
          <Link to="/ordini" className="btn-mc mt-6">I miei ordini</Link>
        </>
      )}
    </div>
  );
}

export function PaymentCancel() {
  return (
    <div data-testid="payment-cancel" className="mx-auto max-w-md px-4 py-20 text-center">
      <XCircle className="mx-auto h-12 w-12" />
      <h1 className="mt-4 text-2xl font-extrabold">Pagamento annullato</h1>
      <p className="mt-2 text-sm text-muted-foreground">Il carrello è ancora qui, puoi riprovare quando vuoi.</p>
      <Link to="/carrello" data-testid="payment-cancel-cart" className="btn-mc mt-6">Torna al carrello</Link>
    </div>
  );
}
